import { useQuery } from '@tanstack/react-query'

import { isDenebEnabled } from '@/const/flags'
import { aspidaClient } from '@/lib/aspida'
import { QueryConfig } from '@/lib/react-query'
import { useProxyStore } from '@/providers/proxyStore/ProxyStoreContext'

import { cartKeyFactory } from './key'

const getCart = (storeCode: string | null) => {
  if (isDenebEnabled && storeCode) {
    return aspidaClient.v1.employee.proxy_stores
      ._storeCode(storeCode)
      .cart.$get()
  }
  return aspidaClient.v1.cart.$get()
}

type UseCartOptions = {
  config?: QueryConfig<typeof getCart>
}

export const useCart = ({ config }: UseCartOptions) => {
  const { storeCode } = useProxyStore()

  const queryConfig: QueryConfig<typeof getCart> = {
    ...config,
    queryKey: cartKeyFactory.detail(),
    queryFn: () => getCart(storeCode),
  }
  return useQuery(queryConfig)
}
